import { Card, Section } from "@snpjs/core";

import { AsyncLoad } from "../../components/asyncLoad/AsyncLoad";
import { IInstallGuideProps } from "./IInstallGuideProps";
import { InstallGuideButton } from "./InstallGuideButton";
import Markdown from "react-markdown";
import { MissingInstallGuideError } from "../../api/errors/MissingInstallGuideError";
import { SystemApi } from "../../api/SystemApi";
import remarkGfm from "remark-gfm";
import styles from "./InstallGuide.module.scss";
import { texts } from "../../i18n/texts";
import { useRequest } from "../../hooks/useRequest";
import { useState } from "react";
import useTranslation from "../../hooks/useTranslation";

export const InstallGuide: React.FC<IInstallGuideProps> = (props) => {
  const [checksumSha1, setChecksumSha1] = useState("");
  const [content, setContent] = useState("");
  const [displayError, setDisplayError] = useState(false);
  const request = useRequest();
  const { t } = useTranslation();

  return (
    <AsyncLoad
      load={async () => {
        await request.send(
          async () => {
            const objid = await SystemApi.findInstallChecklistObjid(
              props.systemObjectId
            );
            setChecksumSha1(objid.CHECKSUM_SHA1);
            const content = await SystemApi.findInstallChecklist(
              props.systemObjectId
            );
            setContent(content);
          },
          (error) => {
            if (error instanceof MissingInstallGuideError) {
              setDisplayError(true);
              return true;
            }
            return false;
          }
        );
      }}
    >
      <div className={styles.center}>
        {displayError && (
          <h3>{t(texts.installChecklist.errorLoadingInstallChecklist)}</h3>
        )}

        <Section
          icon="list-checks"
          title={t(texts.installChecklist.title)}
          rightElement={
            <InstallGuideButton
              objectId={props.systemObjectId}
              checksumSha1={checksumSha1}
            />
          }
        >
          <Card>
            <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
          </Card>
        </Section>
      </div>
    </AsyncLoad>
  );
};
